export default __webpack_public_path__ + "static/media/jhunkFood.7ca3a3b4.gif";